import { designActionTypes, userActionTypes } from '../actions/types';
import { addChanges, getUndo, getRedo } from '../reducers/design.reducer';
import { designService, templateService } from '../services';
// import {
//   EditorState,
//   ContentState,
//   convertFromHTML,
//   convertToRaw,
//   convertFromRaw,
//   RichUtils,
//   SelectionState,
//   Modifier,
// } from 'draft-js';
// import { extractInlineStyle, getCustomStyleMap, toggleCustomInlineStyle } from 'draftjs-utils';
import _ from 'lodash';

const resetState = () => {
  return dispatch => dispatch({ type: designActionTypes.RESET_STATE });
};

const duplicate = (designId, index) => {
  return (dispatch, getState) => {
    dispatch(request());
    const designs = [...getState().design.designs];

    designService.duplicate(getState().authentication.user.userId, designId).then(
      design => {
        designs.splice(index + 1, 0, design);
        dispatch(success(designs));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            designActionTypes.DUPLICATE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: designActionTypes.DUPLICATE_REQUEST };
  }
  function success(designs) {
    return {
      type: designActionTypes.DUPLICATE_SUCCESS,
      designs,
    };
  }
};

const search = (userId, query, clear) => {
  return (dispatch, getState) => {
    dispatch(request());

    let skip = getState().design.designSkip;
    let limit = getState().design.designLimit;

    if (!query.name) {
      delete query.name;
    }

    if (clear || skip === null) {
      skip = 0;
    } else {
      skip = skip + limit;
    }

    designService
      .findAll(userId, {
        ...query,
        skip,
        limit,
      })
      .then(
        designs => {
          dispatch(success(designs, skip, limit, clear));
        },
        error => {
          dispatch(
            _refreshTokenOnFailure(
              error,
              designActionTypes.SEARCH_FAILURE,
              getState().authentication.pendingRefreshingToken,
            ),
          );
        },
      );
  };

  function request() {
    return { type: designActionTypes.SEARCH_REQUEST };
  }
  function success(designs, skip, limit, clear) {
    return { type: designActionTypes.SEARCH_SUCCESS, designs, skip, limit, clear };
  }
};

const getAll = (userId, query, clear) => {
  return (dispatch, getState) => {
    dispatch(request());

    let skip = getState().design.designSkip;
    let limit = getState().design.designLimit;

    if (!query.name) {
      delete query.name;
    }

    if (clear || skip === null) {
      skip = 0;
    } else {
      skip = skip + limit;
    }

    designService
      .findAll(userId, {
        ...query,
        skip,
        limit,
      })
      .then(
        designs => {
          dispatch(success(designs, skip, limit, clear));
        },
        error => {
          dispatch(
            _refreshTokenOnFailure(
              error,
              designActionTypes.SEARCH_FAILURE,
              getState().authentication.pendingRefreshingToken,
            ),
          );
        },
      );
  };

  function request() {
    return { type: designActionTypes.SEARCH_REQUEST };
  }
  function success(designs, skip, limit, clear) {
    return { type: designActionTypes.SEARCH_SUCCESS, designs, skip, limit, clear };
  }
};

const deleteDesign = designId => {
  return (dispatch, getState) => {
    dispatch(request());

    const userId = getState().authentication.user.userId;
    designService.delete(userId, designId).then(
      () => {
        const designs = [...getState().design.designs];
        _.remove(designs, design => {
          return design._id === designId;
        });
        dispatch(success(designs));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            designActionTypes.DELETE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: designActionTypes.DELETE_REQUEST };
  }
  function success(designs) {
    return { type: designActionTypes.DELETE_SUCCESS, designs };
  }
};



const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken) => {
  if (error.error === 'jwt expired') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error };
  }
};


export const designActions = {
  resetState,
  duplicate,
  fetch,
  search,
  getAll,
  deleteDesign,
};
